module.exports = __webpack_public_path__ + "img/big-ms2.c01e0b85.png";